import styled from "styled-components"

export const Styles = styled.section`
  background-color: #fff;
`
